"use client";

import { Button } from "../ui/button";
import { ArrowRight } from "lucide-react";
import Image from "next/image";
import { Handlebars } from "./handlebars";
import Link from "next/link";
import { AUDIENCE } from "@/site/brand";

const POINTS = [
	{ title: "설치 안 함", body: "이 주소만 치면 바로 열립니다" },
	{ title: "가입 안 함", body: "아이디도 비밀번호도 없습니다" },
	{ title: "돈 안 냄", body: "결제 화면이 아예 없습니다" },
	{ title: "워터마크 없음", body: "내보낸 영상에 로고가 안 박힙니다" },
];

export function Hero() {
	return (
		<div className="flex min-h-[calc(100svh-4.5rem)] flex-col items-center justify-between px-4 text-center">
			<Image
				className="absolute top-0 left-0 -z-50 size-full object-cover opacity-85 invert dark:invert-0"
				src="/landing-page-dark.png"
				height={1903.5}
				width={1269}
				alt=""
				aria-hidden
			/>

			<div className="mx-auto flex w-full max-w-3xl flex-1 flex-col justify-center py-16">
				<p className="text-muted-foreground mb-6 text-sm font-medium tracking-wide sm:text-base">
					{AUDIENCE.name}을 위한
				</p>

				<div className="inline-block text-4xl font-bold tracking-tighter md:text-[4rem]">
					<h1>돈 안 내고 쓰는</h1>
					<Handlebars>영상 편집기</Handlebars>
				</div>

				<p className="text-muted-foreground mx-auto mt-10 max-w-xl text-base font-light tracking-wide sm:text-xl">
					찍은 영상을 올리고, 자르고, 자막 넣고, 내려받으면 끝입니다.
					<br className="hidden sm:block" />
					영상은 <span className="text-foreground font-normal">내 컴퓨터 안에서만</span> 처리됩니다.
				</p>

				<div className="mt-9 flex justify-center">
					<Link href="/start">
						<Button size="lg" className="h-12 px-7 text-base">
							바로 시작하기
							<ArrowRight className="ml-0.5" />
						</Button>
					</Link>
				</div>

				<ul className="mx-auto mt-14 grid w-full max-w-2xl grid-cols-2 gap-x-6 gap-y-7 sm:grid-cols-4">
					{POINTS.map((p) => (
						<li key={p.title} className="text-center">
							<p className="text-sm font-semibold sm:text-base">{p.title}</p>
							<p className="text-muted-foreground mt-1.5 text-xs leading-relaxed sm:text-sm">
								{p.body}
							</p>
						</li>
					))}
				</ul>

				<p className="text-muted-foreground mt-14 text-xs leading-relaxed sm:text-sm">
					세로 영상이 기본값입니다. 릴스·쇼츠·당근에 그대로 올리시면 됩니다.
				</p>
			</div>
		</div>
	);
}
